/**
 * Voters workspace role actions.
 *
 * Mirrors `ActionKeys.VotersView` / `ActionKeys.VotersManage` in
 * `backend/iElect.ServiceDefaults/Authorization/ActionKeys.cs`, which api.core's
 * `PermissionBootstrapHostedService` seeds and grants to the admin roles on startup — so a deploy of
 * api.core plus a re-login is all a Super Admin needs. Granted to Super Admin only at launch.
 *
 * - `voters_view`   — the Voters menu entry and the register list (api.query `POST Voters/register`,
 *                     `GET Voters/{id}`).
 * - `voters_manage` — create, duplicate check, import batches and phone reveal on api.command.
 *
 * The menu entry is OR-gated with the older frontend-only `import_voters`, so nobody who imports
 * today loses the page on deploy. Once api.command enforces `voters_manage` on `POST Voters`, an
 * `import_voters`-only role can still OPEN the page but its imports 403 until it is granted the key
 * in Manage Actions — the import surfaces that as "Ask a Super Admin to grant Manage voters".
 */
export const ACTIONS_VOTERS = {
	VOTERS_VIEW: 'voters_view',
	VOTERS_MANAGE: 'voters_manage',
} as const;
